<template>
  <qc-container title="预警信息">
    <div class="flex" >
      <el-form ref="ruleForm" :model="detail" label-width="120px">
        <el-form-item class="row" label="库存预警" >
          <el-switch v-model="detail.warningStatus" :active-value="0" :inactive-value="1"/>
        </el-form-item>
        <el-form-item class="row" label="出售库存低于" >
          <el-input v-model="detail.sellNumber" style="width: 200px" placeholder="请输入阈值" />
        </el-form-item>
        <el-form-item class="tc mr50">
          <el-button class="f14 mr30 " type="primary" @click="submitForm()">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";

export default {
  name: "",
  components: {QcContainer},
  data() {
    return {
      detail:{warningStatus:0,sellNumber:""}
    }
  },
  mixins: [tableBase],
  methods: {
    submitForm(){
      this.simplePost("/api/mgr/business/shop/info/update",this.detail,result=>{
        this.message("保存成功");
      })
    },
    findDetail(){
      this.simpleGet("/api/mgr/business/shop/info/detail",null,result=>{
        let data = result.data;
        this.detail = {id:data.id,warningStatus:data.warningStatus,sellNumber:data.sellNumber};
      })
    }
  },
  mounted() {
    this.findDetail();
  }
}
</script>

<style scoped>

</style>
